/**
 * Publish the open record's visible-tab fields to the screen snapshot (plan 1968 F13).
 * Called once in useRegisterActiveDetailPage, so every registered detail page
 * (StandardDetailPage, Item, Sales Order, side panels) is covered. Read at capture
 * time from the SAVED document — never live form edits.
 */

import type { MutableRefObject } from "react";
import type { TabStructure } from "@/features/inventory/item-detail/utils/buildTabsFromMeta";
import { buildDetailScreenSection, DETAIL_SCREEN_SECTION_ID } from "./detailScreenSection";
import { useScreenCapture } from "./useScreenSection";

export interface DetailScreenArgs {
  enabled: boolean;
  tabs: TabStructure[] | undefined;
  activeTab: string;
  savedRef: MutableRefObject<Record<string, unknown> | null>;
}

export function useDetailScreenSection({ enabled, tabs, activeTab, savedRef }: DetailScreenArgs): void {
  const saved = savedRef.current;
  const version = [saved?.name, saved?.modified, activeTab, tabs?.length].join("|");
  useScreenCapture(
    DETAIL_SCREEN_SECTION_ID,
    enabled ? () => buildDetailScreenSection(tabs ?? [], activeTab, savedRef.current) : null,
    { version },
  );
}
